"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWrapper = void 0;
var react_1 = __importDefault(require("react"));
var ContentWrapper = function (_a) {
    var children = _a.children, footer = _a.footer, subHeader = _a.subHeader, imgHeader = _a.imgHeader, float = _a.float, className = _a.className, rest = __rest(_a, ["children", "footer", "subHeader", "imgHeader", "float", "className"]);
    return (react_1.default.createElement("div", __assign({ className: "content-wrapper  ".concat(footer && 'with-footer', "  ").concat(float && 'with-fab', " ").concat(subHeader && 'with-sub', "\n      ").concat(imgHeader && 'with-img', " ").concat(className !== null && className !== void 0 ? className : '') }, rest), children));
};
exports.ContentWrapper = ContentWrapper;
//# sourceMappingURL=ContentWrapper.js.map